import React from 'react';
import { Box } from '@mui/material';

import SubTabs from 'components/sub-tabs';
import { ScenarioSubTab as Tabs } from '../types/scenario-sub-tab.enum';
import { ScenarioState } from 'views/bluviu-nutrition/types/scenario-state.enum';
import { useR2ScenarioState } from 'views/bluviu-nutrition/features/scenarios-v2/context/r2-scenario-context';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const ScenarioSubTabs: React.FC<Props> = () => {
  const { r2ScenarioQuery: { data: scenario } } = useR2ScenarioState();

  const showAppliedTab = scenario?.appliedAs != null;
  const showResultsTab = scenario?.state === ScenarioState.SCENARIO_RESULT_SENT;

  return (
    <Box display={'flex'} justifyContent={'space-between'}>
      <SubTabs
        tabs={[
          {
            label: 'Setup',
            value: Tabs.SETUP,
          },
          ...(showResultsTab
            ? [
              {
                label: 'Results',
                value: Tabs.RESULTS,
              },
            ]
            : []),
          ...(showAppliedTab
            ? [
              {
                label: 'Applied',
                value: Tabs.APPLIED,
              },
            ]
            : []),
        ]}
      />
    </Box>
  );
};

export default React.memo(ScenarioSubTabs);
